import { Fragment } from 'react';

/**
 * Renders a headline string, converting a single `*word or phrase*` span into
 * the mint serif `<em>` accent the blog design uses. This lets titles and decks
 * live as plain strings in frontmatter while keeping the one-accent-word look.
 *
 *   "The MRR you report isn't the MRR you *earned*."
 *     -> The MRR you report isn't the MRR you <em>earned</em>.
 */
export function Emphasis({ text }: { text: string }) {
  // Odd-indexed parts are the captured groups between the asterisks.
  const parts = text.split(/\*([^*]+)\*/g);
  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1 ? <em key={i}>{part}</em> : <Fragment key={i}>{part}</Fragment>,
      )}
    </>
  );
}
